export default {
    getUrlVal() {
        var url = window.location.href
        var hrefDecoded = decodeURIComponent(url)
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(hrefDecoded);
        return results == null ? null : results[1];
    }

}


// WEBPACK FOOTER //
// ./src/util/util.js